import { Log } from '../../Model/Log';
import { LogRepository } from '../Repositories/LogRepository';

export class UpdateLogUseCase {
  constructor(private repo: LogRepository) {}

  execute(logId: number, payload: Partial<Pick<Log, 'action' | 'description' | 'final_days' | 'end_date' | 'total_days' | 'start_date'>>): Promise<Log> {
    return this.repo.updateLogWithoutRecord(logId, payload);
  }
}


